import styled from 'styled-components/macro';

export const PageTitle = styled.h3`
  margin: 1.5em;
  text-align: center;
`;
